import "./style.scss";

import StyledButton from "components/shared/StyledButton";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { whiteButton } from "components/TitlesList";
import { PortalType } from "contexts/portal.context";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { sendInvitation } from "store/beneficiaryStore";
import { useAppDispatch } from "store/store";

type TProps = {
    close: () => void;
    email: string;
    name: string;
    surname: string;
    beneficiarId: number;
};

const GiveAccess = (props: TProps) => {
    const { close, email, name, surname, beneficiarId } = props;
    const dispatch = useAppDispatch();
    const [t] = useTranslation();
    const [newEmail, setNewEmail] = useState<string | null>();

    const portalType = useContext(PortalType);

    const handleGiveAccess = async () => {
        dispatch(
            sendInvitation({
                id: beneficiarId,
                email: email ?? newEmail,
                name: `${name} ${surname}`,
                needsUpdate: !email,
            }),
        ).then((resp) => {
            if (resp.meta.requestStatus === "fulfilled") {
                close();
            }
        });
    };

    return (
        <div className="give-access-wrapper">
            <div className="give-access-question">
                {`${t("Beneficiars.DoYouWantGiveAccess1")} ${name} ${surname} ${t("Beneficiars.DoYouWantGiveAccess2")}`}
                <ul>
                    <li>{t(`Beneficiars.PortalBenefits1_${portalType}`)}</li>
                    <li>{t("Beneficiars.PortalBenefits2")}</li>
                    <li>{t("Beneficiars.PortalBenefits3")}</li>
                </ul>
                {t("Beneficiars.ModalPortalCanEditPersonalInfos")}
            </div>
            {!email && (
                <div className="give-access-no-mail">
                    <label htmlFor="email">
                        {t("Beneficiars.EmailOf")} {`${name} ${surname}`}
                    </label>
                    <StyledTextField id="email" onChange={(e) => setNewEmail(e.target.value)} />
                </div>
            )}
            <div className="delete-beneficiary-buttons">
                <StyledButton onClick={close} fullWidth sx={{ ...whiteButton, color: "#ED6E6E" }}>
                    {t("Beneficiars.NoDontGive")}
                </StyledButton>
                <StyledButton fullWidth onClick={handleGiveAccess} buttonType="primary" disabled={!email && !newEmail}>
                    {t("Beneficiars.YesGiveAccess")}
                </StyledButton>
            </div>
        </div>
    );
};

export default GiveAccess;
